import { style } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles";

export const h2hNavWrapper = style({
  "@media": {
    [`screen and (min-width: ${breakpoints[1]})`]: {
      width: "33%",
    },
  },
});
